export default __webpack_public_path__ + "static/media/809.a9885ed2.gif";